import React, { ReactNode, useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { StyledTab, StyledTabPanel, StyledTabs } from './styles';

export function a11yProps(index: number) {
  return {
    id: `first-tab-${index}`,
    'aria-controls': `first-tabpanel-${index}`,
  };
}

interface Props {
  tabsList: { label: string; component: ReactNode; dataTestId: string }[];
  isRepoOwner?: string;
  currentValue?: number;
  setCurrentValue?: (value: number) => void;
}

export const GenericFirstLevelTabsList = (props: Props) => {
  const { tabsList, isRepoOwner, currentValue, setCurrentValue } = props;
  const [value, setValue] = useState(currentValue || 0);

  useEffect(() => {
    if (isRepoOwner) {
      setValue(1);
    }
  }, [isRepoOwner]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (setCurrentValue) setCurrentValue(newValue);
    setValue(newValue);
  };

  return (
    <Box>
      <StyledTabs
        value={value}
        onChange={handleChange}
        aria-label="first-level-tabs"
      >
        {tabsList.map((tab, index) => (
          <StyledTab
            label={tab?.label}
            {...a11yProps(index)}
            data-testid={tab.dataTestId}
          />
        ))}
      </StyledTabs>
      {tabsList.map((tab, index) => (
        <StyledTabPanel value={value} index={index}>
          {tab.component}
        </StyledTabPanel>
      ))}
    </Box>
  );
};
